import { createStore } from 'vuex';
import ArticleModule from '@/store/modules/ArticlesModule';
import ProduitModule from './modules/ProduitModule';
import FournisseurModule from './modules/FournisseurModule';
import NatureModule from './modules/NatureModule';
import MarqueModule from './modules/MarqueModule';
import DepartementModule from './modules/DepartementModule';
import AuthModule from './modules/authModule';
import EmplacementModule from './modules/EmplacementModule';
import ZoneModule from './modules/ZoneModule';
import LocationModule from './modules/LocationModule';
import ItemModule from './modules/ItemsModule';
import DetailInventaireModule from '@/store/modules/DetailInventaireModule';
import OperationModule from '@/store/modules/OperationsModule';
import TagModule from '@/store/modules/TagHistoryModule';
import DashboardModule from "@/store/modules/DashboardModule";
import TransfertModule from '@/store/modules/TransfertModule';
import PermissionModule from './modules/PermissionsModule';
import CategorieModule from './modules/CategorieModule';

import  InventoryEmplacementModule from './modules/InventoryEmplacementModule';
import  InventoryDepartmentModule from './modules/InventoryDepartmentModule';
import  InventoryZoneModule from './modules/InventoryZoneModule';
import  InventoryLocationModule  from './modules/InventoryLocationModule';



const store = createStore({
  modules: {
    ArticleModule,
    ProduitModule,
    FournisseurModule,
    NatureModule,
    MarqueModule,
    DepartementModule,
    AuthModule,
    EmplacementModule,
    ZoneModule,
    LocationModule,
    ItemModule,
    DetailInventaireModule,
    OperationModule,
    TagModule,
    DashboardModule,
    TransfertModule,
    PermissionModule,
    CategorieModule,
    InventoryEmplacementModule,
    InventoryDepartmentModule,
    InventoryZoneModule,
    InventoryLocationModule
  },
});

export default store;
